<script>
    import { beforeUpdate, onMount } from "svelte";
    import { writable } from "svelte/store";

    const storedToken = localStorage.getItem("tokenStorage");

    let resultList = [];
    let resultContent = [];

    export let division;
    export let page;
    let test = [];

    onMount(async() => {
        var test = document.location.href.split("/");
        let list = [];
        let result = fetch('https://back.rodvkf72.com:8080/Manage/' + division + '/' + page,
            {
                method: 'POST',
                headers: {
                    "Content-Type" : "application/json",
                    "Authorization" : storedToken,
                }
            }
        ).then((res) => {
            return res.json();
        }).then((json) => {
            list = json;
            console.log(list);
            if (list.result == 'empty') {
                window.location.href="http://rodvkf72.com/Manage/login";    
            } else if (list.result == 'block') {
                window.location.href="http://rodvkf72.com/main";
            }
        });
    
        await result;
        console.log(result);
        resultList = list.list;
        resultContent = resultList[0].content;
    })
</script>

<header class="masthead" style="background-image: url('/Java/image/wale.jpg')">
    <div class="overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-10 mx-auto">
                <div class="site-heading">
                  <h1>Kim's Log</h1>
                  <br>
                  <span class="subheading">관리자 페이지 - {division} </span>
                </div>
            </div>
        </div>
    </div>
</header>

<!-- Main Content -->
<div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-10 mx-auto">
          {#each resultList as item}
            <div class="post-preview">
                <a href="/Manage/{division}/{item.pk}">
                    <p class="post-title" style="text-align: center; font-size: 30px;">
                        {item.title}
                    </p>
                </a>
                <p class="post-meta" style="text-align: right">Posted by 
                    <a href="#">{item.writer}</a>
                    on {item.date}
                </p>
            </div>
            <hr>
          {/each}
      </div>
    </div>
    <a href="http://rodvkf72.com/Manage/board/insert">등록</a>
  </div>
